import { ReducersMapObject, combineReducers, Reducer } from 'redux'
import toggles, { FeatureActions } from 'common/feature-togglings/reducer'
import {
    locationReducer as geoLocation,
    LocationActions,
} from 'common/data/location-detection/reducer'

import { AppState } from 'common/store'
import { navigationReducer as navigation } from 'common/data/navigation/navigation-open'
import { authenticationReducer } from 'common/data/authentication/reducer'
import { userPersonalisationReducer } from 'common/data/user-personalisation/user-personalisation'
import { metaReducer } from 'common/meta/meta.redux'
import { withReduxStateSync } from 'redux-state-sync'
import { consentReducer } from 'common/data/consent/consent.redux'
import { theWestLiveReducer } from 'common/data/west-live/reducer'

export type ActionTypes = FeatureActions | LocationActions

export function createRootReducer(): Reducer<AppState> {
    const reducers: ReducersMapObject<AppState> = {
        toggles,
        geoLocation,
        navigation,
        authentication: authenticationReducer,
        personalisation: userPersonalisationReducer,
        meta: metaReducer,
        consent: consentReducer,
        theWestLive: theWestLiveReducer,
    }

    return withReduxStateSync<AppState>(combineReducers<AppState>(reducers))
}
